import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useSnackbarStore } from '@/stores/snackbar'
import { useEventListener } from '@vueuse/core'

export const useLoaderStore = defineStore('loader', () => {
  const snack = useSnackbarStore()
  const isVisible = ref<boolean>(false)
  const message = ref<string | undefined>(undefined)
  const id = ref<string | undefined>(undefined)
  useEventListener(window, 'message', (e) => {
    if (e.data?.type === 'loader-show') {
      show(e.data.message)
    } else if (e.data?.type === 'loader-hide') {
      hide()
    }
  })
  function show(msg?: string) {
    id.value && snack.remove(id.value)
    isVisible.value = true
    id.value = snack.add(msg ?? 'Loading...', { noClose: true, permanent: true, type: 'loader' })
  }

  function showCustom(componentToImport: () => Promise<any>) {
    isVisible.value = true
    id.value = snack.add(componentToImport, { noClose: true, permanent: true, custom: true })
  }

  function hide() {
    isVisible.value = false
    id.value && snack.remove(id.value)
  }

  return { isVisible, message, show, showCustom, hide }
})
